export const isSiteDown = false;

export const ports = {
  en: 3000,
  la: 3003,
};

export const apiList = {
  development: process.env.DEVELOPMENT_API_ENDPOINT,
  staging: "https://staging-api.abcya.com",
  production: "https://api.abcya.com",
};

export const debugEnvs = ["staging", "development", "test"];

/* mimics web-client"s scss variables _app.scss */
export const abcyaMainColorPalette = {
  lightGrey: "#e5e2df",
  grey: "#848479",
  darkGrey: "#3d3d3a",
  green: "#99dd17",
  darkGreen: "#16c41f",
  lightGreen: "#C9F414",
  lightCyan: "#38E57E",
  cyan: "#12cca8",
  darkCyan: "#108C99",
  yellow: "#ffc41d",
  orange: "#ffaa00",
  darkOrange: "#f77116",
  lightOrange: "#FFD527",
  red: "#e24829",
  darkRed: "#CE2E2E",
  dark: "#001E27",
  darkDark: "#001723",
  lightDark: "#0C3439",
  purple: "#A05CF7",
  darkPurple: "#6B42D1",
  lightPurple: "#C471FF",
  ptSteel: "#91B3B7",
  ptCyan: "#00A39B",
  ptGrey: "#f4f4f4",
};

export const variousURLs = {
  abcya: {
    development: {
      en: `https://local.abcya.com:${ports.en}`,
      la: `https://local.abcya.com:${ports.la}`,
    },
    testing: { en: "https://testing.abcya.com", la: "testing.abcya.com" },
    staging: { en: "https://staging.abcya.com", la: "https://la-staging.abcya.com" },
    production: { en: "https://www.abcya.com", la: "https://la.abcya.com" },
  },
  affiliateMarketing: "http://app.impact.com/campaign-campaign-info-v2/ABCya.brand",
  facebook: "https://www.facebook.com/ABCyaGames/",
  twitter: "https://twitter.com/abcyagames",
  instagram: "https://www.instagram.com/abcyagames/",
  vimeo: "https://vimeo.com/abcya",
  ixl: {
    base: { en: "https://www.ixl.com", la: "https://la.ixl.com" },
    manage: {
      family: {
        en: "https://www.ixl.com/membership/family/manage",
        la: "https://la.ixl.com/afiliacion/familiar/manage",
      },
    },
  },
  rosettaStone: { en: "https://www.rosettastone.com/", la: "https://espanol.rosettastone.com/" },
  vocabulary: "https://www.vocabulary.com/",
  education: "https://www.education.com/",
  wyzant: "https://www.wyzant.com/",
  spanishDict: "https://www.spanishdict.com/",
  ingles: "https://www.ingles.com/",
  emmersion: "https://emmersion.ai/",
  tpt: "https://www.teacherspayteachers.com/",
  arcademics: {
    intro: "https://ideas.arcademics.com/ideas/affiliates/affiliateAbcyaLogo2019.gif",
    game: "https://static.arcademics.com/games-html5",
  },
  nativeManage: {
    IOS: "https://buy.itunes.apple.com/WebObjects/MZFinance.woa/wa/manageSubscriptions",
    ANDROID: "https://play.google.com/store/account/subscriptions",
    AMAZON: "https://www.amazon.com/gp/mas/your-account/myapps/yoursubscriptions",
  },
  nativeDownload: {
    IOS: "https://apps.apple.com/us/app/abcya-games/id1079974015",
    ANDROID: "https://play.google.com/store/apps/details?id=com.abcya.android.games",
    AMAZON: "https://www.amazon.com/ABCya-com-LLC-ABCya-Games/dp/B075M2VXLX",
  },
  productOfferings: {
    abcyaBingo: {
      IOS: "https://apps.apple.com/us/app/abcya-bingo-collection/id1617645138",
      ANDROID: "https://play.google.com/store/apps/details?id=com.abcya.android.bingo2",
      AMAZON: "https://www.amazon.com/ABCya-com-LLC-ABCya-BINGO-Collection/dp/B09X6B5VHL/",
    },
    createACar: {
      IOS: "https://apps.apple.com/us/app/create-a-car/id388173036",
    },
    donutDrop: {
      IOS: "https://apps.apple.com/us/app/donut-drop-by-abcya/id1355825388",
      ANDROID: "https://play.google.com/store/apps/details?id=com.abcya.donutdrop",
      AMAZON: "https://www.amazon.com/ABCya-com-LLC-Donut-Drop-ABCya/dp/B07BGF1HBL",
    },
    dreidel: {
      IOS: "https://apps.apple.com/us/app/dreidel-by-abcya/id1322013425",
    },
    mathBingo: {
      IOS: "https://apps.apple.com/us/app/math-bingo/id371338715",
    },
    wordBingo: {
      IOS: "https://apps.apple.com/us/app/word-bingo/id406264088",
    },
  },
  schema: "https://schema.org",
  logo: { en: "https://www.abcya.com/static/assets/logo.png", la: "https://la.abcya.com/static/assets/logo.png" },
  adDetect: [
    "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",
    "https://neodarwin-prod.sdcdns.com/main/prebid-min-2023.js",
  ],
  abcyaStore: "https://abcya.myspreadshop.com",
  // adDetect: "https://px.moatads.com/pixel.gif"
  googleFonts: {
    montserrat: {
      regular: "https://fonts.googleapis.com/css2?family=Montserrat&display=swap",
    },
  },
};

export const assetsUrls = {
  development: "https://assets-development.abcya.com/",
  staging: "https://assets-staging.abcya.com/",
  production: "https://assets.abcya.com/",
};

export const mediaUrls = {
  development: "content-staging.abcya.com",
  testing: "content-testing.abcya.com",
  staging: "content-staging.abcya.com",
  production: "media.abcya.com",
};

export const language = {
  default: "en",
  la: "la",
  codes: {
    en: "en_US",
    la: "es_US",
  },
  stripeLocales: {
    // https://docs.stripe.com/js/appendix/supported_locales
    la: "es-419",
  },
  resetHash: "#resetLang",
  preferenceToken: "abcya_lang_pref",
};

export const startupDataKey = "startupData";

export const gotwListShortname = "gotw";

export const publicFavLimit = 3;

export const arcademicsIntroDuration = 3400;

export const giftCardAmount = {
  minimum: 10,
  maximum: 500,
  increment: 5,
};

// user planGroups/roles
export const userRoles = {
  free: "PUBLIC",
  student: "STUDENT",
  classroom: "CLASSROOM",
  school: "SCHOOL",
  family: "FAMILY",
};

// content types mostly used regarding minibanners and search
export const contentTypesData = {
  all: { en: "all", la: "todo" },
  blog: { en: "blog" },
  faq: { en: "faq", la: "preguntas-frecuentes" },
  game: { en: "game", la: "juego" },
  link: { en: "link", la: "enlace" },
  standard: { en: "standard" },
  printable: { en: "printable", la: "imprimible" },
};

export const contentTypes = {
  all: contentTypesData.all[language.default],
  blog: contentTypesData.blog[language.default],
  faq: contentTypesData.faq[language.default],
  game: contentTypesData.game[language.default],
  link: contentTypesData.link[language.default],
  standard: contentTypesData.standard[language.default],
  printable: contentTypesData.printable[language.default],
};

// content (video) ad types
export const contentAdTypes = {
  preroll: "PREROLL",
  clickToPlay: "CLICK_TO_PLAY",
  none: "NONE",
};

export const categoryTypes = ["games", "coloring-pages", "activity-pages", "worksheets", "teacher-resources"];

// games that require motion controls
// request api permission in mobile safari
export const motionGames = [
  "fuzzathlon",
  "equivalent-fractions-bingo",
  "fuzz_bugs_factory_hop",
  "halloween_hop",
  "rih",
  "dolch-sight-word-bingo",
  "world-bingo",
  "state-bingo",
  "spanish-bingo",
  "shapes-colors-bingo",
  "number-bingo",
  "money-bingo",
  "math-bingo",
  "math_stack",
  "base-ten-bingo",
  "alphabet-bingo",
  "abcya_game_framework_v2",
];

export const roleKey = "abcRole";
export const sessionGameplaysKey = "abcya_session_gameplays";

// same as the API schema enum BillingPlatform
// web will only ever use the one, rest are for native platforms
export const billingPlatform = "STRIPE";

// native billing platforms
export const nativePlatforms = ["AMAZON", "ANDROID", "IOS"];

// for gift card code length see common shared files
// utilities/forms/rules.js { validGiftcard }

export const giftcardAmounts = [10, 25, 50, 100];

export const giftcardQuantity = 10;

export const blogPosts = {
  initial: 6,
  additional: 3,
};

export const breakpoints = {
  // breakpoints should mimic breakpoints also defined in stylesheets
  width: {
    xs: 360,
    sm: 640,
    md: 768,
    lg: 1024,
    // adsLG: 1250, // 1024  - 800px with 2 skyscraper ads (160 x 600) and padding
    adsLG: 1330, // 1024  - 800px with 2 skyscraper ads (160 x 600) and padding
    xl: 1440,
    adsXL: 1554, // 1440 - 1024 with 2 skyscraper ads (160 x 600) and padding
    xxl: 1920,
  },
};

// sky right data backup
/* sky: {
      left: "div-gpt-ad-1657882894107-0",

    }, */
// CMAS
const cmasCDNHost =
  process.env.NODE_ENV === "production" ? "https://cmas.sdcdns.com/" : "https://cmas-staging.sdcdns.com/";

export const adData = {
  divIds: {
    leader: {
      desktop: ["abcHeader", "abcMiddle1", "abcMiddle2", "abcMiddle3", "abcTopLeader", "abcBotLeader"],
      mobile: ["abcHeaderSmall", "abcMiddleSmall1", "abcMiddleSmall2", "abcMiddleSmall3"],
    },
    sky: {
      left: "abcSideLong",
      right: "abcSideLong2",
    },
    billboard: "abcSide",
    adhesion: "abcAdhesion",
    video: {
      ap: "abcPrerollAp",
      ctp: "abcPrerollCtp",
    },
  },
  preloadScripts: [
    {
      rel: "preload",
      href: "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
      as: "script",
    },
    {
      rel: "preload",
      href: "https://imasdk.googleapis.com/js/sdkloader/ima3.js",
      as: "script",
    },
  ],
  headScripts: [
    {
      text: `(function(h,o,u,n,d) { h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}; d=o.createElement(u);d.async=1;d.src=n; n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n); })(window,document,"script","https://www.datadoghq-browser-agent.com/us1/v5/datadog-logs.js","DD_LOGS"); window.DD_LOGS.onReady(function() { window.DD_LOGS.init({ clientToken: "pube90a3590ca3db2ddad751d224feb033f", site: "datadoghq.com", forwardErrorsToLogs: false, sessionSampleRate: 100, service: "abcya", env: "${process.env.NODE_ENV}", }) });`,
    },
    {
      src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
      async: true,
    },
    {
      src: `${cmasCDNHost}abc/main-min.js`,
      async: true,
      crossorigin: "anonymous",
    },
  ],
};

export const kidsafeData = {
  seal: {
    divId: "ksp-seals",
    scriptId: "ksp-seals-script",
    dataProduct: "yy4xuBjeeoqZh50sSgug0yVoln1ZidaP7l8y8R4u",
    scriptSrc: "https://kidsafe.com/js/seals/seals.js",
  },
};

export const stripePublishableKeys = {
  test: "pk_test_rcKmM9Ij6bqWmLsJnutJEgGH",
  development: "pk_test_rcKmM9Ij6bqWmLsJnutJEgGH",
  staging: "pk_test_rcKmM9Ij6bqWmLsJnutJEgGH",
  production: "pk_live_N7s0PurhLVSw4SZoBqNnAkX9",
};

export const recaptchaSiteKey =
  process.env.NODE_ENV === "production"
    ? `6Ldq8tIqAAAAALho4_71qpCoJ2_nkIRZnrEc3glR`
    : `6LeGgNIqAAAAABCgH5wIqr_Zbn77NOamX_pXAMbF`;

export const recaptchaScriptSrc = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaSiteKey}`;

// must match error string used in api
// nexus/config/default.json -> errors.authorized
export const AUTH_ERROR = "Not Authorized";

export const HOME_LIST_COUNT = 5;

export const EMAIL_CHAR_LIMIT = 320;

export const PASSWORD_CHAR_LIMIT = 64;

export const PASSWORD_CHAR_MINIMUM = 6;

export const ACCESS_NAME_CHAR_LIMIT = 256;

export const TEXT_FIELD_CHAR_LIMIT = 1000;

export const DEVICE_COUNT_CHAR_LIMIT = 7;

export const STUDENT_COUNT_CHAR_LIMIT = 5;

export const FREE_GAMES_LIST_COUNT = 6;

export const searchParamData = {
  name: { en: "name", la: "nombre" },
  code: { en: "code", la: "codigo" },
  path: { en: "path", la: "ruta" },
  term: { en: "term", la: "condicion" },
  id: { en: "id", la: "identificacion" },
  type: { en: "type", la: "tipo" },
  grade: { en: "grade", la: "grado" },
  subscription: { en: "subscription", la: "suscripcion" },
};

export const mixpanelProjectToken =
  process.env.NODE_ENV === "production" ? "e005eb98032f42bb2b81fcf7a9c5fd08" : "726fccb6760d8d0bcfa2fec10a59e2b4";

export const abTestLocalStorageKey = "mp_ab_test";

// Mixpanel A/B Test Config; key is the game shortname
export const abTestConfig = {};

export const mixpanelAbandonedMethods = {
  navigate: "navigated away",
  unload: "closed tab/browser",
};

export const codesOfServerErrors = {
  USER_EXISTS_WHEN_SUBSCRIBED: "subscribe.error.userExistsWhenSubscribed",
};
